import axios from 'axios';
import withDecrypt from '../../src/withDecrypt';

async function fetchAPI(query, { variables, preview } = {}) {
  return axios({
    method: 'post',
    url: process.env.NEXT_PUBLIC_API_URL,
    data: {
      query,
    },
  })
    .then(resp => withDecrypt(resp.data))
    .catch(err => {
      console.log(err);
    });
}
export default async function getRevenueData(code) {
  let queryStr = '';
  // let code = "FUNDS1067983_AAPL_SHR";
  let _code = code.replace(/[\.\@\|\$\^\:]/g, '_');
  const data = await fetchAPI(`
      query{
        ${_code}: getRevData(code: "${code}") {
            code: seriesCode
            value
            recordDate
        }
      }
    `,
  )
  return data
}
